const dropdownRefHandler = (
  openDropdownRef: any,
  onToggle?: (isOpening: boolean) => void,
) => (el: any) => {
  if (el) {
    const originalOnToggle = el.onToggle;
    if (originalOnToggle && openDropdownRef) {
      el.onToggle = async (event: Event) => {
        const isOpening = !el.isOpen;
        if (isOpening) {
          // Reset state before opening to avoid one-frame submenu flicker.
          onToggle?.(true);
        }

        await originalOnToggle?.call(el, event);
        // Store reference when dropdown opens, clear when it closes
        if (el.isOpen) {
          openDropdownRef.current = el;
        } else if (openDropdownRef.current === el) {
          openDropdownRef.current = null;
          onToggle?.(false);
        }
      };
    }
  }
};

export default dropdownRefHandler;
